import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";


export const FetchVersionesSistema = () => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`Versionado`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.abmVersionadoSuccess,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar las versiones del sistema.", "Ha ocurrido un error. Intente Nuevamente")
        dispatch({type: types.abmPlazosError})
    }

}

export const BuscarVersionesSistema = (text) => (dispatch) =>{
    dispatch({
        type : types.abmBuscarVersionado,
        payload : text
    });
}

export const agregarVersionSistema = (datos) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Versionado`, datos, "POST");
        const body = await response.json();

        if (response.ok) {
            dispatch(startAlerta("Versión cargada correctamente", 'success', 'Comando Exitoso'))
            dispatch(finishSpinner());
            dispatch(FetchVersionesSistema());
            
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear un plazo.", "Ha ocurrido un error. Intente nuevamente")
    }
};